import script from "./EditCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCampaign.vue?vue&type=script&setup=true&lang=js"

import "./EditCampaign.vue?vue&type=style&index=0&id=7027cd0d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7027cd0d"]])

export default __exports__